// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1RapQ","content":"RecentSearches_content__1KCHY"};